import React from 'react';
import PropTypes from 'prop-types';
import { Asset } from '@components/Asset';
import Paragraph from '@components/Paragraph';
import { isEmpty } from '@helpers/isEmpty';
import { imageContainer, tileContainer } from './accreditationsTile.module.css';

function AccreditationsTile({ accreditations, text }) {
  return (
    <div className={tileContainer}>
      {!isEmpty(text) && (
        <Paragraph hasNoMargin>
          <strong>{text}</strong>
        </Paragraph>
      )}
      <div className={imageContainer}>
        {accreditations?.map((accreditation) =>
          accreditation.elements.chunk_images.value[0] ? (
            <Asset
              key={accreditation.elements.chunk_images.value[0].system.id}
              renderMode="container"
              {...accreditation.elements.chunk_images.value[0]}
            />
          ) : null
        )}
      </div>
    </div>
  );
}

AccreditationsTile.propTypes = {
  accreditations: PropTypes.array,
  text: PropTypes.string,
};

export default AccreditationsTile;
